import { CenterPage } from '@tucan/login'
import React, { FC, ReactNode } from 'react'
import { getPublicEnv } from '@tucan/utils'

interface Props {
  children: ReactNode
  footer?: boolean
}

/** `@tucan/login`'s centered page with the deployment's background image (`BACKGROUND_URL`). */
export const PageCenter: FC<Props> = (props) => {
  return (
    <CenterPage background={getPublicEnv('BACKGROUND_URL') || undefined}>
      {props.children}
    </CenterPage>
  )
}
